// extracted by mini-css-extract-plugin
export default {"container":"CareTips_container__-NoCA","title":"CareTips_title__C9vM+","list":"CareTips_list__zCXal"};